'use client';

import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Chip } from '@packages/shared/src/ui/Chip/Chip';

export const ScrollTopButtonBase: FC = () => {
  const { formatMessage } = useIntl();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Chip
      className="text-[13px] shadow-md"
      iconPosition="start"
      iconClassName="icon-emp-arrow-medium-up mx-0.5"
      onClick={scrollToTop}
      label={formatMessage({
        id: 'scrollToTopButton',
        defaultMessage: 'Nach oben',
      })}
    />
  );
};

export const ScrollTopButton: FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.pageYOffset > window.innerHeight);
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`transition-opacity duration-300 ${show ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
    >
      <ScrollTopButtonBase />
    </div>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default ScrollTopButton;
